import { useEffect } from 'react'
import { usePostHog, useFeatureFlagEnabled, useFeatureFlagPayload } from 'posthog-js/react'
import { FeatureFlagEnum } from '@vacationtracker/shared/types/feature-flags'

interface UsePostHogFeatureFlagResult<T = any> {
  enabled: boolean
  payload: T
}

export const useIsPostHogFeatureFlagEnabledForCompany = <T = any>(
  featureFlag: FeatureFlagEnum,
  companyId?: string,
  userId?: string
): UsePostHogFeatureFlagResult<T> => {
  const posthog = usePostHog()
  const enabled = useFeatureFlagEnabled(featureFlag)
  const payload = useFeatureFlagPayload(featureFlag) as T

  useEffect(() => {
    if (!companyId || !userId) {
      return
    }

    posthog.identify(userId)
    posthog.setGroupPropertiesForFlags({
      company: {
        id: companyId,
      },
    })
  }, [userId, companyId, posthog])

  return {
    enabled: Boolean(enabled),
    payload,
  }
}
